import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TransferPricingDocumentationRequestHelper } from './transfer-pricing-documentation-request-helper';
import type { ITransferPricingDocumentationRecordResponse } from './types';

/** Pass null to disable the request entirely. */
export const useTransferPricingDocumentationRecord = (
  documentationId: string | null
) => {
  const { data, error, isLoading, mutate } =
    useSWR<ITransferPricingDocumentationRecordResponse>(
      documentationId
        ? TransferPricingDocumentationRequestHelper.recordPath(documentationId)
        : null,
      SWRFetcher({ method: 'GET' })
    );

  return {
    documentation: data?.documentation ?? null,
    isLoading,
    error,
    mutate,
  };
};
